import { Gap } from "../../atoms";
// import InputAdornment from "@mui/material/InputAdornment";
// import SearchIcon from "@mui/icons-material/Search";
import Profile from "./Profile";
// import ProfileTabs from "./ProfileTabs";
// import Table from "./Table";

const ExcoPusat = () => {
  return (
    <div style={{ marginLeft: 20, marginRight: 20 }}>
      <Gap height={20} />
      {/* <div style={{ display: "flex", justifyContent: "space-between" }}>
        <p style={{ fontSize: 28, fontWeight: 700, marginBottom:'8px' }}>EXCO Pusat</p>
      </div> */}
      <Profile />
      {/* <Gap height={20} />
      <ProfileTabs /> */}
      <Gap height={50} />
      {/* <Table /> */}
    </div>
  );
};

export default ExcoPusat;
